import { Menu } from "@base-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { preventDefaultAndStopPropagation } from "shared/lib/preventDefaultAndStopPropagation"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { MyProfileCardHeaderWidgetViewModel } from "./MyProfileCardHeaderWidgetView"

export const MyProfileCardActionsMenu = React.memo(
  ({
    onDeleteProfile
  }: Pick<MyProfileCardHeaderWidgetViewModel, "onDeleteProfile">) => {
    const { t } = useTranslation()
    return (
      <Menu.Root defaultOpen={false}>
        <Menu.Trigger
          data-testid="my-profile__actions"
          className={classNames(
            "btn",
            "btn-secondary",
            "btn-secondary--muted",
            "btn--icon-only"
          )}
          aria-label={t("UserProfile.Actions.Actions")}
          onClick={preventDefaultAndStopPropagation}
        >
          <Icon name={IconName.KEBAB} size={IconSize.MEDIUM} />
        </Menu.Trigger>

        <Menu.Portal>
          <Menu.Positioner
            className="menu__positioner"
            align="end"
            side="bottom"
            sideOffset={16}
            positionMethod="fixed"
          >
            <Menu.Popup
              className={classNames("menu__popup")}
              data-testid="my-profile-actions__delete-profile"
              onClick={preventDefaultAndStopPropagation}
            >
              <Menu.Item
                aria-label={t("UserProfile.DeleteProfile.DeleteProfile")}
                onClick={onDeleteProfile}
                className={classNames(
                  "btn",
                  "btn-menu",
                  "menu__item",
                  "btn--danger"
                )}
              >
                <Icon name={IconName.BIN} />
                <span>{t("UserProfile.DeleteProfile.DeleteProfile")}</span>
              </Menu.Item>
            </Menu.Popup>
          </Menu.Positioner>
        </Menu.Portal>
      </Menu.Root>
    )
  }
)
